export type color = 'white' | 'black' | 'near-black'

export function getColor(color: color | string) {
    return {
        'white': '#fff',
        'black': '#000',
        'near-black': '#141414',
    }?.[color] ?? color;
}